/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/DarkMode';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DarkModeIcon = withMuiAdapter(Base, 'DarkMode');
